import { BookingTypeRequests } from '@/services/booking-type.requests'
const bookingTypeService = new BookingTypeRequests()

const state = {
  list: []
}

const getters = {}

const actions = {
  list ({ state }) {
    return new Promise((resolve, reject) => {
      bookingTypeService.list().then(async (bookingTypes) => {
        state.list = bookingTypes
        resolve(bookingTypes)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
